<template>
  <ProSpaceGeoLayout class="competence" v-if="model">
    <template #top>
      <ProSpaceTopPanel :header="layoutName" back @back="backHandler"> </ProSpaceTopPanel>
    </template>
    <template #center>
      <ProSpaceGeoLayout
        :is-templated="true"
        :template-center="true"
        :template-right="true"
        :routeName="$route.name"
      >
        <template #center>
          <ProSpaceTabs
            v-model="modelTab"
            :tabs="overviewTabs"
            :loading="loading"
            :refLoading="refLoading"
            without-margin-bottom
            @select-tab="handlerSelectTab"
          >
            <ProSpaceHLayout :gap="10">
              <ProSpaceAction
                v-if="isCreation || isDraft"
                ref="saveDraft-ProSpaceAction"
                :disabled="disabledDraftSave"
                :text="$t('saveDraft')"
                @click="saveDraft"
              />
              <ProSpaceAction
                v-if="isCreation || isDraft"
                ref="publish-ProSpaceAction"
                :disabled="disabledPublish"
                icon="check"
                :text="$t('publish')"
                @click="publish"
              />
              <ProSpaceAction
                v-if="!(isCreation || isDraft)"
                ref="save-ProSpaceAction"
                :disabled="disabledSave"
                icon="check"
                :text="$t('save')"
                @click="save"
              />
            </ProSpaceHLayout>
            <template v-slot:tab-1>
              <ProSpaceVLayout>
                <!-- Агентство -->
                <ProSpaceGeoLayout
                  v-if="checkAccess('distributorBlock-ProSpaceGeoLayout')"
                  class="geo-row"
                >
                  <template v-slot:left>
                    <ProSpaceTextBlock
                      :top="$t('distributorNameTxt')"
                      :bottom="$t('distributorInfoAdditional')"
                      :gap="10"
                      type="third"
                      break-word
                    />
                  </template>
                  <template v-slot:center>
                    <ProSpaceVLayout
                      justify-content="space-between"
                      align-items="flex-start"
                      :gap="20"
                    >
                      <ProSpaceSearchfield
                        style="width: calc(50% - 5px)"
                        ref="agencyId-ProSpaceSearchfield"
                        v-model="model.agencyId"
                        getMethod="grid"
                        optionValue="id"
                        optionLabel="value"
                        filterModel="value"
                        :displayValue="model.agencyValue"
                        :label="$t('addressProgramOrderAgencyValue')"
                        :txtTitleModal="$t('addressProgramOrderAgencyValue')"
                        :searchPlaceholder="$t('addressProgramOrderAgencyValue')"
                        :applyTxt="$t('applyTxt')"
                        :cancelTxt="$t('cancelTxt')"
                        :service="agencyService"
                        :columns="agencyColumns"
                        :fastFilters="[]"
                        :defaultFilter="{ disabled: { and: [false] } }"
                        :grid-styles="searchFieldGridStyles"
                        :invalid="v$.model.agencyId.$error"
                        :invalid-messages="v$.model.agencyId.$errors"
                        @apply="handlerApplySearchfield($event, 'agency')"
                        @blur="v$.model.agencyId.$touch"
                      />
                    </ProSpaceVLayout>
                  </template>
                  <template v-if="v$.model.agencyId.$error" v-slot:right>
                    <ProSpaceWarning />
                  </template>
                </ProSpaceGeoLayout>

                <!-- Общая информация -->
                <ProSpaceGeoLayout class="geo-row">
                  <template v-slot:left>
                    <ProSpaceTextBlock
                      :top="$t('competenceDirectoryInfo')"
                      :bottom="$t('competenceDirectoryInfoAdditional')"
                      :gap="10"
                      type="third"
                      break-word
                    />
                  </template>
                  <template v-slot:center>
                    <ProSpaceVLayout
                      justify-content="space-between"
                      align-items="flex-start"
                      :gap="20"
                    >
                      <ProSpaceHLayout
                        v-if="!isCreation && !isDraft"
                        align-items="flex-start"
                        :gap="10"
                        isInlineH
                      >
                        <ProSpaceDropdown
                          v-if="!(isCreation || isDraft)"
                          ref="status-ProSpaceDropdown"
                          v-model="model.newStatus"
                          :label="$t('competenceStatusTxt')"
                          :placeholder="$t('competenceStatusTxt')"
                          :service="baseTypeService"
                          getMethod="grid"
                          propValue="code"
                          propLabel="name"
                          :argMethod="statusDropdownArgMethod"
                          style="width: calc(50% - 5px)"
                          @change="statusChange"
                          :invalid="v$.model.newStatus.$error"
                          :invalid-messages="v$.model.newStatus.$errors"
                          @blur="v$.model.newStatus.$touch"
                        />
                      </ProSpaceHLayout>
                      <ProSpaceHLayout align-items="flex-start" :gap="10" isInlineH>
                        <ProSpaceSearchfield
                          ref="hsrId-ProSpaceSearchfield"
                          v-model="model.hsrId"
                          getMethod="grid"
                          optionValue="id"
                          optionLabel="value"
                          filterModel="value"
                          :displayValue="model.hsrValue"
                          :label="$t('hSR')"
                          :txtTitleModal="$t('hSR')"
                          :searchPlaceholder="$t('hSRValue')"
                          :applyTxt="$t('applyTxt')"
                          :cancelTxt="$t('cancelTxt')"
                          :service="hsrService"
                          :columns="hsrColumns"
                          :fastFilters="[]"
                          :defaultFilter="{ disabled: { and: [false] } }"
                          :invalid="v$.model.hsrId.$error"
                          :invalid-messages="v$.model.hsrId.$errors"
                          :grid-styles="searchFieldGridStyles"
                          @blur="v$.model.hsrId.$touch"
                        />
                        <ProSpaceSearchfield
                          ref="areaId-ProSpaceSearchfield"
                          v-model="model.areaId"
                          getMethod="grid"
                          optionValue="id"
                          optionLabel="value"
                          filterModel="value"
                          :displayValue="model.areaValue"
                          :label="$t('area')"
                          :txtTitleModal="$t('area')"
                          :searchPlaceholder="$t('areaValue')"
                          :applyTxt="$t('applyTxt')"
                          :cancelTxt="$t('cancelTxt')"
                          :service="areaService"
                          :columns="areaColumns"
                          :fastFilters="[]"
                          :defaultFilter="{ disabled: { and: [false] } }"
                          :invalid="v$.model.areaId.$error"
                          :invalid-messages="v$.model.areaId.$errors"
                          :grid-styles="searchFieldGridStyles"
                          @blur="v$.model.areaId.$touch"
                        />
                      </ProSpaceHLayout>
                      <ProSpaceHLayout align-items="flex-start" :gap="10" isInlineH>
                        <ProSpaceSearchfield
                          ref="competenceDirectories-ProSpaceSearchfield"
                          v-model="model.competenceDirectoryId"
                          optionLabel="name"
                          optionValue="id"
                          getMethod="grid"
                          filterModel="name"
                          icon="list-check"
                          defaultSortField="createdAt"
                          :defaultSortOrder="-1"
                          :label="$t('competenceDirectoryName')"
                          :inputPlaceholder="$t('competenceDirectoryNamePlaceholder')"
                          :searchPlaceholder="$t('searchTxt')"
                          :cancelTxt="$t('cancelTxt')"
                          :applyTxt="$t('select')"
                          :txtTitleModal="$t('competenceSelect')"
                          :displayValue="model.competenceDirectoryName"
                          :service="competenceDirectoryService"
                          :columns="columns"
                          :fastFilters="[]"
                          :defaultFilter="{ disabled: { and: [false] } }"
                          :txtFilterHint="$t('filterBy')"
                          @apply="
                            handlerApplySearchfield($event, 'competenceDirectories')
                          "
                          :invalid="v$.model.competenceDirectoryId.$error"
                          :invalid-messages="v$.model.competenceDirectoryId.$errors"
                          @blur="v$.model.competenceDirectoryId.$touch"
                        >
                          <template #filters="{ filter }">
                            <ProSpaceMultiSelect
                              :localization="$t"
                              v-model="filter.block"
                              :service="baseTypeService"
                              getMethod="grid"
                              optionLabel="name"
                              optionValue="code"
                              :default-filter="{
                                disabled: false,
                                systemDirectoryCode: 'BlockType',
                              }"
                              :placeholderValue="$t('competenceDirectoryBlock')"
                              :selectAllTxt="$t('selectAllTxt')"
                              :closeTxt="$t('closeTxt')"
                              :applyTxt="$t('applyTxt')"
                              :clearFilterTxt="$t('clearFilterTxt')"
                              @apply="
                                (model) =>
                                  customFilterApply(
                                    filter,
                                    model,
                                    'competenceDirectories-ProSpaceSearchfield'
                                  )
                              "
                            />

                            <ProSpaceMultiSelect
                              :localization="$t"
                              v-model="filter.type"
                              :service="baseTypeService"
                              getMethod="grid"
                              optionLabel="name"
                              optionValue="code"
                              :default-filter="{
                                disabled: false,
                                systemDirectoryCode: 'CompetenceType',
                              }"
                              :placeholderValue="$t('competenceDirectoryType')"
                              :selectAllTxt="$t('selectAllTxt')"
                              :closeTxt="$t('closeTxt')"
                              :applyTxt="$t('applyTxt')"
                              :clearFilterTxt="$t('clearFilterTxt')"
                              @apply="
                                (model) =>
                                  customFilterApply(
                                    filter,
                                    model,
                                    'competenceDirectories-ProSpaceSearchfield'
                                  )
                              "
                            />
                            <ProSpaceCustomFilterPanel
                              :customTxt="$t('custom')"
                              :customFilterTxt="$t('customFilterTxt')"
                              :clearFilterTxt="$t('clearFilterTxt')"
                              :selectAllTxt="$t('selectAllTxt')"
                              :closeTxt="$t('closeTxt')"
                              :applyTxt="$t('applyTxt')"
                              :fromTxt="$t('fromTxt')"
                              :toTxt="$t('toTxt')"
                              :services="competenceDirectoryFilterService"
                              @apply="
                                (model) =>
                                  customFilterApply(
                                    filter,
                                    model,
                                    'competenceDirectories-ProSpaceSearchfield'
                                  )
                              "
                            />
                          </template>
                          <template #columns>
                            <Column
                              field="name"
                              :header="this.$t('competenceDirectoryName')"
                              sortable
                              headerClass="move-sort-head"
                            >
                              <template #body="field">
                                <ProSpaceTableHeaderCell
                                  v-if="field.data"
                                  :title="field.data.name"
                                />
                              </template>
                            </Column>

                            <Column
                              field="block"
                              :header="this.$t('competenceDirectoryBlock')"
                              sortable
                              headerClass="move-sort-head"
                              style="min-width: 95px"
                            >
                              <template #body="field">
                                <ProSpaceDefaultTextColumn :title="field.data.blockName">
                                  {{ field.data.blockName }}
                                </ProSpaceDefaultTextColumn>
                              </template>
                            </Column>

                            <Column
                              field="level"
                              :header="this.$t('competenceDirectoryLevel')"
                              sortable
                              headerClass="move-sort-head"
                              style="min-width: 95px"
                            >
                              <template #body="field">
                                <ProSpaceDefaultTextColumn :title="field.data.levelName">
                                  {{ field.data.levelName }}
                                </ProSpaceDefaultTextColumn>
                              </template>
                            </Column>

                            <Column
                              field="type"
                              :header="this.$t('competenceDirectoryType')"
                              sortable
                              headerClass="move-sort-head"
                              style="min-width: 95px"
                            >
                              <template #body="field">
                                <ProSpaceDefaultTextColumn
                                  :title="$t(field.data.typeName)"
                                >
                                  {{ $t(field.data.typeName) }}
                                </ProSpaceDefaultTextColumn>
                              </template>
                            </Column>
                          </template>
                          <template #panel="{ item }">
                            <ProSpaceRightPanel
                              :header="headerPanelCompetenceDirectories(item)"
                            >
                              <template #center>
                                <ProSpacePanelBlock
                                  :header="headerBlockCompetenceDirectories"
                                >
                                  <template v-slot>
                                    <ProSpacePanelBlockList
                                      :list="contentBlockCompetenceDirectories(item)"
                                      :itemsPerPage="7"
                                    />
                                  </template>
                                </ProSpacePanelBlock>
                              </template>
                            </ProSpaceRightPanel>
                          </template>
                        </ProSpaceSearchfield>
                        <ProSpaceDropdown
                          ref="levelDevelopment-ProSpaceDropdown"
                          v-model="model.levelDevelopment"
                          :label="$t('competenceLevelDevelopment')"
                          :placeholder="$t('competenceLevelDevelopment')"
                          :service="baseTypeService"
                          getMethod="grid"
                          propValue="code"
                          propLabel="name"
                          argMethod="$filter=systemDirectoryCode eq 'AdvancementLevelType' and disabled eq false"
                          @change="levelDevelopmentChange"
                          :invalid="v$.model.levelDevelopment.$error"
                          :invalid-messages="v$.model.levelDevelopment.$errors"
                          @blur="v$.model.levelDevelopment.$touch"
                        />
                      </ProSpaceHLayout>
                      <ProSpaceHLayout align-items="flex-start" :gap="10" isInlineH>
                        <ProSpaceInputText
                          ref="competenceDirectoryBlock-ProSpaceInputText"
                          v-model="model.competenceDirectoryBlockName"
                          :label="$t('competenceDirectoryBlock')"
                          :placeholder="$t('competenceDirectoryBlock')"
                          :hint="$t('competenceAutoCompletePlaceholder')"
                        />
                        <ProSpaceInputText
                          ref="competenceDirectoryLevel-ProSpaceInputText"
                          v-model="model.competenceDirectoryLevelName"
                          :label="$t('competenceDirectoryLevel')"
                          :placeholder="$t('competenceDirectoryLevel')"
                          :hint="$t('competenceAutoCompletePlaceholder')"
                        />
                      </ProSpaceHLayout>
                      <ProSpaceInputText
                        ref="competenceDirectoryType-ProSpaceInputText"
                        v-model="model.competenceDirectoryTypeName"
                        :label="$t('competenceDirectoryType')"
                        :placeholder="$t('competenceDirectoryType')"
                        :hint="$t('competenceAutoCompletePlaceholder')"
                        style="width: calc(50% - 5px)"
                      />
                      <ProSpaceExtendedTextArea
                        ref="competenceDirectoryDescription-ProSpaceExtendedTextArea"
                        v-model="model.competenceDirectoryDescription"
                        :placeholder="$t('competenceDirectoryDescription')"
                        :label="$t('competenceDirectoryDescription')"
                        :hint="$t('competenceAutoCompletePlaceholder')"
                        :t="$t"
                        :locale="$i18n.locale"
                      />
                      <ProSpaceExtendedTextArea
                        ref="competenceDirectoryAdvancementRecommendation-ProSpaceExtendedTextArea"
                        v-model="model.competenceDirectoryAdvancementRecommendation"
                        :placeholder="$t('competenceDirectoryAdvancementRecommendations')"
                        :label="$t('competenceDirectoryAdvancementRecommendations')"
                        :hint="$t('competenceAutoCompletePlaceholder')"
                        :t="$t"
                        :locale="$i18n.locale"
                      />
                      <ProSpaceHLayout align-items="flex-start" :gap="10" isInlineH>
                        <ProSpaceInputCalendar
                          ref="startAt-ProSpaceInputCalendar"
                          v-model="model.startAt"
                          :label="$t('competenceStartAt')"
                          :placeholder="$t('competenceStartAt')"
                          :invalid="v$.model.startAt.$error"
                          :invalid-messages="v$.model.startAt.$errors"
                          @blur="v$.model.startAt.$touch"
                        />
                        <ProSpaceInputCalendar
                          ref="endAt-ProSpaceInputCalendar"
                          v-model="model.endAt"
                          :label="$t('competenceEndAt')"
                          :placeholder="$t('competenceEndAt')"
                          :invalid="v$.model.endAt.$error"
                          :invalid-messages="v$.model.endAt.$errors"
                          @blur="v$.model.endAt.$touch"
                        />
                      </ProSpaceHLayout>
                    </ProSpaceVLayout>
                  </template>
                  <template
                    v-if="
                      v$.model.newStatus.$error ||
                      v$.model.competenceDirectoryId.$error ||
                      v$.model.levelDevelopment.$error ||
                      v$.model.startAt.$error ||
                      v$.model.endAt.$error
                    "
                    v-slot:right
                  >
                    <ProSpaceWarning />
                  </template>
                </ProSpaceGeoLayout>

                <!-- Развитие компетенции -->
                <ProSpaceGeoLayout class="geo-row">
                  <template v-slot:left>
                    <ProSpaceTextBlock
                      :top="$t('competenceDevelopmentInfo')"
                      :bottom="$t('competenceDevelopmentInfoAdditional')"
                      :gap="10"
                      type="third"
                      break-word
                    />
                  </template>
                  <template v-slot:center>
                    <ProSpaceVLayout
                      justify-content="flex-start"
                      align-items="flex-start"
                      :gap="20"
                    >
                      <ProSpaceInputNumber
                        ref="developmentPercentage-ProSpaceInputNumber"
                        v-model="model.developmentPercentage"
                        style="width: calc(50% - 5px)"
                        likeText
                        :integeronly="false"
                        :maxFractionDigits="0"
                        :min="0"
                        :max="100"
                        :formatter="formatDigit"
                        :label="$t('competenceDevelopmentPercentage')"
                        :placeholder="$t('competenceDevelopmentPercentage')"
                        :invalid="v$.model.developmentPercentage.$error"
                        :invalid-messages="v$.model.developmentPercentage.$errors"
                        @blur="v$.model.developmentPercentage.$touch"
                      />
                      <ProSpaceExtendedTextArea
                        ref="businessGoal-ProSpaceExtendedTextArea"
                        v-model="model.businessGoal"
                        :placeholder="$t('competenceBusinessGoalPlaceholder')"
                        :label="$t('competenceBusinessGoal')"
                        :t="$t"
                        :locale="$i18n.locale"
                        :invalid="v$.model.businessGoal.$error"
                        :invalid-messages="v$.model.businessGoal.$errors"
                        @blur="v$.model.businessGoal.$touch"
                      />
                    </ProSpaceVLayout>
                  </template>
                  <template
                    v-if="
                      v$.model.developmentPercentage.$error ||
                      v$.model.businessGoal.$error
                    "
                    v-slot:right
                  >
                    <ProSpaceWarning />
                  </template>
                </ProSpaceGeoLayout>

                <!-- Результат и метрики -->
                <ProSpaceGeoLayout class="geo-row">
                  <template v-slot:left>
                    <ProSpaceTextBlock
                      :top="$t('competenceResultsAndMetricsInfo')"
                      :bottom="$t('competenceResultsAndMetricsInfoAdditional')"
                      :gap="10"
                      type="third"
                      break-word
                    />
                  </template>
                  <template v-slot:center>
                    <ProSpaceVLayout
                      justify-content="space-between"
                      align-items="flex-start"
                      :gap="20"
                    >
                      <ProSpaceExtendedTextArea
                        ref="expectedResult-ProSpaceExtendedTextArea"
                        v-model="model.expectedResult"
                        :placeholder="$t('competenceExpectedResultTxtPlaceholder')"
                        :label="$t('competenceExpectedResult')"
                        :t="$t"
                        :locale="$i18n.locale"
                        :invalid="v$.model.expectedResult.$error"
                        :invalid-messages="v$.model.expectedResult.$errors"
                        @blur="v$.model.expectedResult.$touch"
                      />
                      <ProSpaceExtendedTextArea
                        ref="metrics-ProSpaceExtendedTextArea"
                        v-model="model.metrics"
                        :placeholder="$t('competenceMetricsTxtPlaceholder')"
                        :label="$t('competenceMetrics')"
                        :t="$t"
                        :locale="$i18n.locale"
                        :invalid="v$.model.metrics.$error"
                        :invalid-messages="v$.model.metrics.$errors"
                        @blur="v$.model.metrics.$touch"
                      />
                    </ProSpaceVLayout>
                  </template>
                  <template
                    v-if="v$.model.expectedResult.$error || v$.model.metrics.$error"
                    v-slot:right
                  >
                    <ProSpaceWarning />
                  </template>
                </ProSpaceGeoLayout>
              </ProSpaceVLayout>
            </template>
            <template v-slot:tab-2>
              <ProSpaceGeoLayout class="geo-row geo-row--no-border">
                <template v-slot:left>
                  <ProSpaceTextBlock
                    :top="$t('competenceTasks')"
                    :bottom="$t('competenceAdvancementTasks')"
                    :gap="10"
                    type="third"
                    break-word
                  />
                </template>
                <template v-slot:center>
                  <ProSpaceVLayout
                    justify-content="space-between"
                    align-items="flex-start"
                    :gap="20"
                  >
                    <ProSpaceButton
                      v-if="!(isCreation || isDraft)"
                      ref="showCreateTaskModal-ProSpaceButton"
                      type="secondary"
                      icon="plus"
                      class="margin-bottom-30"
                      :label="$t('taskCreate')"
                      @click="showCreateTaskModal"
                    />
                  </ProSpaceVLayout>
                </template>
              </ProSpaceGeoLayout>
              <ProSpaceGeoLayout style="height: calc(100% - 70px)">
                <template #center>
                  <ProSpaceMainGrid
                    v-if="!(mixinLoadingAccess || statusMixinLoadingAccess)"
                    ref="competenceTaskGrid"
                    getMethod="grid"
                    defaultSortField="id"
                    isHeadHide
                    removeBgOnly
                    :defaultSortOrder="-1"
                    :service="competenceTaskService"
                    :defaultFilter="{
                      competenceId: { and: [+masterId] },
                      disabled: { and: [false] },
                    }"
                    :isInForm="true"
                    @selected-change="competenceTaskSelectedHandler"
                    @loaded="tryOpenTaskFromNotification"
                  >
                    <template #columns>
                      <Column style="max-width: 39%">
                        <template #body="field">
                          <ProSpaceVLayout :gap="5" justify-content="center">
                            <div
                              class="text-color-main text-bold text-ellipsis w-100"
                              style="line-height: 14px"
                            >
                              {{ field.data.name }}
                            </div>
                            <ProSpaceTag
                              is-border-style
                              v-bind="
                                mapExpandStatuses.get(field.data.status) || {
                                  type: 'draft',
                                  text: field.data.status,
                                }
                              "
                            />
                          </ProSpaceVLayout>
                        </template>
                      </Column>
                      <Column style="max-width: 18%">
                        <template #body="field">
                          <ProSpaceTextBlock
                            type="five"
                            :top="$t('competenceTaskAssignmentTo')"
                            :bottom="$t(field.data.assignmentTo)"
                            :gap="3"
                            justify-content="center"
                          />
                        </template>
                      </Column>
                      <Column style="max-width: 14%">
                        <template #body="field">
                          <ProSpaceTextBlock
                            type="five"
                            :top="$t('competenceStartAt')"
                            :bottom="formatMomentDate(field.data.startAt)"
                            :gap="3"
                            justify-content="center"
                          />
                        </template>
                      </Column>
                      <Column style="max-width: 17%">
                        <template #body="field">
                          <ProSpaceTextBlock
                            type="five"
                            :top="$t('competenceEndAt')"
                            :bottom="formatMomentDate(field.data.endAt)"
                            :gap="3"
                            justify-content="center"
                          />
                        </template>
                      </Column>
                      <Column style="max-width: 12%">
                        <template #body="field">
                          <ProSpaceTextBlock
                            type="five"
                            :top="$t('competenceTaskPriority')"
                            :bottom="
                              field.data.priority !== null &&
                              field.data.priority !== undefined
                                ? String(field.data.priority)
                                : null
                            "
                            :gap="3"
                            justify-content="center"
                          />
                        </template>
                      </Column>
                      <Column field="actions" class="column-end column-end-90">
                        <template #body="field">
                          <ProSpaceHLayout :gap="10" justify-content="flex-end">
                            <ProSpaceIcon
                              v-if="field.data.isAnyAttachment"
                              icon="paperclip"
                            />
                            <ProSpaceTag
                              v-if="field.data.daysExpired"
                              :text="field.data.daysExpired"
                              :description="$t('overdueDayHint')"
                              type="red-secondary"
                            />
                            <ProSpaceDots
                              :options="
                                localWrapperCheckRoles(competenceTaskOptions, field.data)
                              "
                              @action="
                                (action) => handleCompetenceTaskDots(action, field.data)
                              "
                            />
                          </ProSpaceHLayout>
                        </template>
                      </Column>
                    </template>
                    <template #empty>
                      <div></div>
                    </template>
                  </ProSpaceMainGrid>
                </template>
              </ProSpaceGeoLayout>
              <CompetenceTaskModalForm
                v-model="showTaskModal"
                :id="taskModalId"
                :competence="taskModalCompetence"
                :minStartAt="taskModalCompetenceStartAt"
                :maxEndAt="taskModalCompetenceEndAt"
                :afterSaveHandler="handleCompetenceTaskModalFormSavedData"
              />
              <ProSpaceHistoryModal
                ref="competenceTaskHistory"
                v-model="showCompetenceTaskHistoryModal"
                modelName="CompetenceTaskApiModel"
                :optionsPanel="optionsPanel"
                @close="closeHistory"
              />
            </template>
          </ProSpaceTabs>
        </template>
        <template #right>
          <ProSpaceRightPanel
            v-if="masterId && model.status && !isCompetenceTaskSelected"
            no-border
            :header="panelBlockHeader"
          >
            <template #center>
              <ProSpaceTimeLineCondition
                :elems="model.comments"
                :commentTile="$t('comment')"
                :title="$t('comments')"
                :titleAction="$t('addComment')"
                :dateTimeFormatter="formatTimelineDate"
                :showMarker="false"
                @add="showReasonModal(addComment, $t('addComment'))"
              >
                <template #empty>
                  <ProSpaceEmptyGrid
                    v-if="!model.comments || model.comments.length == 0"
                    style="padding-top: 100px"
                    icon="empty-grid"
                    :title="$t('noDataTitle')"
                    :text="$t('noDataTxt')"
                  />
                </template>
              </ProSpaceTimeLineCondition>
              <ProSpaceModal
                v-model="modalShow"
                icon="plus"
                :title="modalTitle"
                :width="530"
                :cancelTxt="$t('cancelTxt')"
                :applyTxt="$t('send')"
                :validate-local="$t"
                :validate-model="modalModel"
                :validate-config="{
                  comment: {
                    required,
                  },
                }"
                @apply="saveComment"
                @cancel="cancelComment"
              >
                <template #default="{ v }">
                  <ProSpaceVLayout :gap="20">
                    <ProSpaceInputText
                      class="prospace-competence-input-layout"
                      v-model="modalModel.comment"
                      :label="$t('comment')"
                      :placeholder="$t('comment')"
                      :isTextarea="true"
                      :invalid="v.comment.$error"
                      :invalid-messages="v.comment.$errors"
                      @blur="v.comment.$touch"
                    />
                  </ProSpaceVLayout>
                </template>
              </ProSpaceModal>
            </template>
          </ProSpaceRightPanel>
          <CompetenceTaskPanel
            v-if="hasSelect && isCompetenceTaskSelected"
            ref="right-panel"
            :service="competenceTaskService"
            :options="competenceTaskOptions"
            :checkAccess="checkAccess"
            :checkStatusAccess="checkStatusAccess"
            :filterAccessDots="localWrapperCheckRoles"
            @edit="showEditTaskModal"
          />
        </template>
      </ProSpaceGeoLayout>
      <ProSpaceFlashMessage
        v-if="isStatusNotify"
        v-model="isStatusNotify"
        type="default"
        icon="flash-warning"
        :title="
          newStatus === 'Completed'
            ? $t('competenceStatusCompletedNotifyTitle')
            : $t('competenceStatusCanceledNotifyTitle')
        "
        :applyTxt="$t('accept')"
        :cancelTxt="$t('cancelTxt')"
        @apply="applyStatusChange"
        @cancel="cancelStatusChange"
      >
        {{
          newStatus === "Completed"
            ? $t("competenceStatusCompletedNotifyAdditional")
            : $t("competenceStatusCanceledNotifyAdditional")
        }}
      </ProSpaceFlashMessage>
      <ProSpaceFlashMessage
        v-if="showCopyCompetenceTaskMessage"
        v-model="showCopyCompetenceTaskMessage"
        :title="$t('copyCreation')"
        :applyTxt="$t('confirmTxt')"
        :cancelTxt="$t('cancelTxt')"
        @apply="() => save(true)"
      >
        <div v-html="$t('competenceCopyMsg', { agencyName: model.agencyValue })" />
        <br />
        <ProSpaceRadioButton
          v-model="copyCompetenceRadioButtonModel"
          :values="copyCompetenceTaskOptions"
        />
      </ProSpaceFlashMessage>
      <ProSpaceFlashMessage
        v-if="showCopiedTaskDatesChanged"
        icon="flash-success"
        v-model="showCopiedTaskDatesChanged"
        :title="$t('copiedTaskDatesChanged')"
        :cancelTxt="$t('closeTxt')"
      >
        <div v-html="$t('inProcessOfCopyingTaskDatesChanged')" />
      </ProSpaceFlashMessage>
      <ProSpaceFlashMessage
        v-if="showTaskDeleteModal"
        v-model="showTaskDeleteModal"
        type="default"
        icon="flash-warning"
        :title="$t('deletingConfirmation')"
        :applyTxt="$t('confirmTxt')"
        :cancelTxt="$t('reject')"
        @apply="applyTaskDelete"
      >
        <ProSpaceVLayout :gap="10" justify-content="center" align-items="center">
          <div
            class="text-color-gray text-bold"
            style="padding: 0 5px"
            v-html="$t('deleteCompetenceTask', { name: taskDeletingModel.name })"
          ></div>
        </ProSpaceVLayout>
      </ProSpaceFlashMessage>
    </template>
  </ProSpaceGeoLayout>
</template>
<script>
import accessMixin from "../../../../../Frontends/Common/utils/elementAccess/accessMixin";
import statusAccessMixin from "../../../../../Frontends/Common/utils/elementAccess/statusAccessMixin";
import {
  ProSpaceTopPanel,
  ProSpaceInputText,
  ProSpaceAction,
  ProSpaceRadioButton,
  ProSpaceGeoLayout,
  ProSpacePanelBlock,
  ProSpacePanelBlockList,
  ProSpaceRightPanel,
  ProSpaceTableHeaderCell,
  ProSpaceTabs,
  ProSpaceTextBlock,
  ProSpaceHLayout,
  ProSpaceVLayout,
  ProSpaceDropdown,
  ProSpaceFile,
  ProSpaceInputCalendar,
  ProSpaceInputNumber,
  ProSpaceExtendedTextArea,
  ProSpaceDefaultTextColumn,
  ProSpaceSearchfield,
  ProSpaceMultiSelect,
  ProSpaceCustomFilterPanel,
  ProSpaceTimeLineCondition,
  ProSpaceModal,
  ProSpaceIcon,
  ProSpaceButton,
  ProSpaceWarning,
  ProSpaceSimpleGrid,
  ProSpaceEmptyGrid,
  ProSpaceDivider,
  ProSpaceMainGrid,
  ProSpaceTag,
  ProSpaceDots,
  ProSpaceFlashMessage,
} from "@prospace/prospace-components-library";
import moment from "moment";
import CompetenceTaskPanel from "./components/CompetenceTaskPanel";
import CompetenceTaskModalForm from "./../CompetenceTasks/components/CompetenceTaskModalForm";
import ProSpaceHistoryModal from "../../../../../Frontends/ProSpace/components/modals/ProSpaceHistoryModal";
import { CompetenceService } from "../../services/CompetenceService.js";
import { CompetenceDirectoryService } from "../../services/CompetenceDirectoryService.js";
import { CompetenceCommentService } from "../../services/CompetenceCommentService.js";
import { BaseTypeService } from "../../../../BaseType/BaseTypeService.Frontend/services/BaseTypeService.js";
import { CompetenceTaskService } from "../../services/CompetenceTaskService";
import { AgencyService } from "../../../../AddressProgram/AddressProgram.Frontend/services/AgencyService.js";
import { HSRService } from "../../../../AddressProgram/AddressProgram.Frontend/services/HSRService.js";
import { AreaService } from "../../../../AddressProgram/AddressProgram.Frontend/services/AreaService.js";
import Column from "primevue/column";
import { required, maxLength, helpers, minValue, maxValue } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import { useMultiSelectGrid } from "@composes/multiselect";
import { mapGetters } from "vuex";
import { ref } from "vue";
import { formatBytes, downloadFile } from "@common/utils/fileHelpers.js";
import _ from "lodash";
export default {
  mixins: [accessMixin, statusAccessMixin],
  components: {
    Column,
    ProSpaceTopPanel,
    ProSpaceGeoLayout,
    ProSpaceInputText,
    ProSpaceAction,
    ProSpaceRadioButton,
    ProSpacePanelBlock,
    ProSpacePanelBlockList,
    ProSpaceRightPanel,
    ProSpaceTableHeaderCell,
    ProSpaceTabs,
    ProSpaceTextBlock,
    ProSpaceHLayout,
    ProSpaceVLayout,
    ProSpaceDropdown,
    ProSpaceFile,
    ProSpaceInputCalendar,
    ProSpaceInputNumber,
    ProSpaceExtendedTextArea,
    ProSpaceDefaultTextColumn,
    ProSpaceSearchfield,
    ProSpaceMultiSelect,
    ProSpaceCustomFilterPanel,
    ProSpaceTimeLineCondition,
    ProSpaceModal,
    ProSpaceIcon,
    ProSpaceButton,
    ProSpaceWarning,
    ProSpaceSimpleGrid,
    ProSpaceEmptyGrid,
    ProSpaceDivider,
    ProSpaceMainGrid,
    ProSpaceTag,
    ProSpaceDots,
    CompetenceTaskPanel,
    CompetenceTaskModalForm,
    ProSpaceFlashMessage,
    ProSpaceHistoryModal,
  },
  setup() {
    const competenceTaskGrid = ref(null);
    const {
      selectedMultipleGridHandler,
      selectedMultipleClear,
      selectedData,
      hasSelect,
      selectedMultipleBlockFilterHandler,
    } = useMultiSelectGrid(competenceTaskGrid);
    return {
      v$: useVuelidate(),
      competenceTaskGrid,
      selectedMultipleGridHandler,
      selectedData,
      hasSelect,
      selectedMultipleClear,
      selectedMultipleBlockFilterHandler,
    };
  },
  data() {
    let statusDraftConfig = {
      AgencyAdministrator: "READONLY",
      AgencySupervisor: "READONLY",
      COAdministrator: {
        none: "ALIVE",
        Draft: "ALIVE",
        other: "READONLY",
      },
      COSupervisor: {
        none: "ALIVE",
        Draft: "ALIVE",
        other: "READONLY",
      },
      Administrator: {
        none: "ALIVE",
        Draft: "ALIVE",
        other: "READONLY",
      },
    };
    let statusCDConfig = {
      AgencyAdministrator: "READONLY",
      AgencySupervisor: "READONLY",
      COAdministrator: {
        none: "DISABLE",
        Draft: "DISABLE",
        other: "READONLY",
      },
      COSupervisor: {
        none: "DISABLE",
        Draft: "DISABLE",
        other: "READONLY",
      },
      Administrator: {
        none: "DISABLE",
        Draft: "DISABLE",
        other: "READONLY",
      },
    };
    let statusConfig = {
      AgencyAdministrator: "READONLY",
      AgencySupervisor: "READONLY",
      COAdministrator: {
        other: "ALIVE",
      },
      COSupervisor: {
        other: "ALIVE",
      },
      Administrator: {
        other: "ALIVE",
      },
    };
    let statusButtonsTaskConfig = {
      AgencyAdministrator: {
        Draft: "NONE",
        other: "ALIVE",
      },
      AgencySupervisor: {
        Draft: "NONE",
        other: "ALIVE",
      },
      COAdministrator: {
        Draft: "NONE",
        other: "ALIVE",
      },
      COSupervisor: {
        Draft: "NONE",
        other: "ALIVE",
      },
      Administrator: {
        Draft: "NONE",
        other: "ALIVE",
      },
    };
    let deleteTaskConfig = {
      "Agency administrator": "NONE",
      "Agency supervisor": "NONE",
      Administrator: "ALIVE",
      "CO administrator": "ALIVE",
    };
    let defaultSearchFieldColumns = [{ field: "code", header: this.$t("code") }];
    let agencyColumns = [
      ...defaultSearchFieldColumns,
      { field: "value", header: this.$t("agencyValue") },
    ];
    let hsrColumns = [
      ...defaultSearchFieldColumns,
      { field: "value", header: this.$t("hSRValue") },
    ];
    let areaColumns = [
      ...defaultSearchFieldColumns,
      { field: "value", header: this.$t("areaValue") },
    ];
    return {
      // Tabs
      modelTab: {
        name: this.$t("parameters"),
        isActive: true,
        systemName: "parameters",
      },

      // Common
      model: null,
      initModel: null,
      loading: false,

      // Service
      competenceService: new CompetenceService(),
      competenceDirectoryService: new CompetenceDirectoryService(),
      competenceCommentService: new CompetenceCommentService(),
      baseTypeService: new BaseTypeService(),
      competenceTaskService: new CompetenceTaskService(),
      agencyService: new AgencyService(),
      hsrService: new HSRService(),
      areaService: new AreaService(),
      getMethod: "get",
      masterId: null,

      nodeFilter: {
        add: {},
        remove: {},
      },
      gridFilter: {
        add: {},
        remove: {},
      },
      oDataStringFilter: "",
      selectedTreeNodes: {},

      modalTitle: "",
      modalCallback: null,
      modalShow: false,
      modalModel: {
        comment: "",
      },
      isCompetenceTaskSelected: false,

      //task modal
      competenceTaskIdFromNotification: null,
      taskModalId: null,
      taskModalCompetence: null,
      taskModalCompetenceStartAt: null,
      taskModalCompetenceEndAt: null,
      showTaskModal: false,
      showCompetenceTaskHistoryModal: false,

      isStatusNotify: false,
      newStatus: "",
      oldStatus: "",

      //status access
      statusAccessConfig: {
        "agencyId-ProSpaceSearchfield": statusDraftConfig,
        "competenceDirectories-ProSpaceSearchfield": statusDraftConfig,
        "levelDevelopment-ProSpaceDropdown": statusDraftConfig,
        "competenceDirectoryLevel-ProSpaceInputText": statusCDConfig,
        "competenceDirectoryBlock-ProSpaceInputText": statusCDConfig,
        "competenceDirectoryType-ProSpaceInputText": statusCDConfig,
        "competenceDirectoryDescription-ProSpaceExtendedTextArea": statusCDConfig,
        "competenceDirectoryAdvancementRecommendation-ProSpaceExtendedTextArea": statusCDConfig,

        "startAt-ProSpaceInputCalendar": statusConfig,
        "endAt-ProSpaceInputCalendar": statusConfig,
        "developmentPercentage-ProSpaceInputNumber": statusConfig,
        "businessGoal-ProSpaceExtendedTextArea": statusConfig,
        "expectedResult-ProSpaceExtendedTextArea": statusConfig,
        "metrics-ProSpaceExtendedTextArea": statusConfig,
        "hsrId-ProSpaceSearchfield": statusConfig,
        "areaId-ProSpaceSearchfield": statusConfig,

        "editTask-option": statusButtonsTaskConfig,
        "subtaskCreate-action": statusButtonsTaskConfig,
        "deleteTask-option": deleteTaskConfig,
      },

      //competence copy
      copyCompetenceTaskOptions: [
        {
          value: "true",
          label: this.$t("createTaskCopies"),
        },
        {
          value: "false",
          label: this.$t("doNotCreateTaskCopies"),
        },
      ],
      copyCompetenceRadioButtonModel: "false",
      showCopyCompetenceTaskMessage: false,
      copySourceId: null,
      showCopiedTaskDatesChanged: false,
      parentTasksExist: false,
      agencyColumns: agencyColumns,
      hsrColumns: hsrColumns,
      areaColumns: areaColumns,
      taskDeletingModel: null,
      showTaskDeleteModal: false,
    };
  },
  validations() {
    return {
      model: {
        agencyId: {
          required: helpers.withMessage(this.$t("requiredFieldErrorMessage"), required),
        },
        hsrId: {
          required: helpers.withMessage(this.$t("requiredFieldErrorMessage"), required),
        },
        areaId: {
          required: helpers.withMessage(this.$t("requiredFieldErrorMessage"), required),
        },
        newStatus: {
          maxLength: helpers.withMessage(
            this.$t("maxLengthErrorMessage"),
            maxLength(100)
          ),
        },
        competenceDirectoryId: {
          required: helpers.withMessage(this.$t("requiredFieldErrorMessage"), required),
        },
        levelDevelopment: {
          required: helpers.withMessage(this.$t("requiredFieldErrorMessage"), required),
        },
        developmentPercentage: {
          required: helpers.withMessage(this.$t("requiredFieldErrorMessage"), required),
          minValue: helpers.withMessage(this.$t("minValueErrorMessage"), minValue(0)),
          maxValue: helpers.withMessage(this.$t("maxValueErrorMessage"), maxValue(100)),
        },
        businessGoal: {
          required: helpers.withMessage(this.$t("requiredFieldErrorMessage"), required),
        },
        expectedResult: {
          required: helpers.withMessage(this.$t("requiredFieldErrorMessage"), required),
        },
        metrics: {
          required: helpers.withMessage(this.$t("requiredFieldErrorMessage"), required),
        },
        startAt: {
          required: helpers.withMessage(this.$t("requiredFieldErrorMessage"), required),
          mustBeLessThanEnd: helpers.withMessage(
            this.$t("dateMustBeLessThanEnd"),
            this.checkStartDate
          ),
        },
        endAt: {
          required: helpers.withMessage(this.$t("requiredFieldErrorMessage"), required),
          mustBeGreaterThanStart: helpers.withMessage(
            this.$t("dateMustBeGreaterThanStart"),
            this.checkEndDate
          ),
        },
      },
    };
  },
  mounted() {
    if (this.$route.query && this.$route.query.CompetenceTaskId) {
      this.competenceTaskIdFromNotification = this.$route.query.CompetenceTaskId;
      this.modelTab = {
        name: this.$t("tasks"),
        systemName: "tasks",
        isActive: true,
      };
    }

    this.loadRoleAccess();
    this.masterId = this.$route.params.id;
    this.copySourceId = this.$route.query.copySourceId;
    this.getData().then(() => {
      this.setAllAccess();
    });
  },
  methods: {
    formatTimelineDate(date) {
      return this.getFormatDateTime(date);
    },
    tryOpenTaskFromNotification() {
      if (!this.competenceTaskIdFromNotification) return;

      this.showEditTaskModal({ id: this.competenceTaskIdFromNotification });
      this.competenceTaskIdFromNotification = null;
    },
    emptyComment() {
      return {
        comment: "",
      };
    },
    checkStartDate(value) {
      return (
        moment(value).format("YYYYMMDD") <= moment(this.model.endAt).format("YYYYMMDD")
      );
    },
    checkEndDate(value) {
      return (
        moment(value).format("YYYYMMDD") >= moment(this.model.startAt).format("YYYYMMDD")
      );
    },
    setAllAccess(clear = false) {
      this.$nextTick(() => {
        if (clear) this.clearAllCondition();
        this.mountAccess();
        this.mountStatusAccess();
      });
    },
    levelDevelopmentChange(item) {
      this.model.levelDevelopment = item && item.code ? item.code : null;
    },
    statusChange(item) {
      let newStatus = item && item.code ? item.code : null;
      if (newStatus === "Canceled" || newStatus === "Completed") {
        this.isStatusNotify = true;
        this.newStatus = newStatus;
      } else {
        this.model.newStatus = newStatus;
        this.oldStatus = newStatus;
      }
    },
    applyStatusChange() {
      this.isStatusNotify = false;
      this.model.newStatus = this.newStatus;
    },
    cancelStatusChange() {
      this.isStatusNotify = false;
      this.newStatus = null;
      this.model.newStatus = this.oldStatus;
    },
    handlerApplySearchfield(data, field) {
      if (!data && field === "agency") {
        this.model.agencyValue = null;
        return;
      } else if (!data && field === "competenceDirectories") {
        this.model.competenceDirectoryName = null;
        this.model.competenceDirectoryBlock = null;
        this.model.competenceDirectoryBlockName = null;
        this.model.competenceDirectoryLevel = null;
        this.model.competenceDirectoryLevelName = null;
        this.model.competenceDirectoryType = null;
        this.model.competenceDirectoryTypeName = null;
        this.model.competenceDirectoryDescription = null;
        this.model.competenceDirectoryAdvancementRecommendation = null;
      } else if (field === "agency") {
        this.model.agencyValue = data.value;
        // this.distributorStructureService.setDistributorId(data.id);
      } else if (field === "competenceDirectories") {
        this.model.competenceDirectoryName = data.name;
        this.model.competenceDirectoryBlock = data.block;
        this.model.competenceDirectoryBlockName = data.blockName;
        this.model.competenceDirectoryLevel = data.level;
        this.model.competenceDirectoryLevelName = data.levelName;
        this.model.competenceDirectoryType = data.type;
        this.model.competenceDirectoryTypeName = data.typeName;
        this.model.competenceDirectoryDescription = data.description;
        this.model.competenceDirectoryAdvancementRecommendation =
          data.advancementRecommendation;
      }
    },
    customFilterApply(filter, model, refName) {
      filter = Object.assign(filter, model);
      this.$refs[refName].$refs["filter-panel"].submitFilter();
    },
    headerPanelCompetenceDirectories(competenceDirectory) {
      return {
        title: competenceDirectory.name,
        id: competenceDirectory.id,
        showCounter: false,
      };
    },
    contentBlockCompetenceDirectories(competenceDirectory) {
      return [
        [
          {
            title: this.$t("competenceDirectoryBlock"),
            text: competenceDirectory.blockName,
          },
        ],
        [
          {
            title: this.$t("competenceDirectoryLevel"),
            text: competenceDirectory.levelName,
          },
        ],
        [
          {
            title: this.$t("competenceDirectoryType"),
            text: competenceDirectory.typeName,
          },
        ],
        [
          {
            title: this.$t("competenceDirectoryDescription"),
            text: competenceDirectory.description,
            isHtml: true,
          },
        ],
        [
          {
            title: this.$t("competenceDirectoryAdvancementRecommendation"),
            text: competenceDirectory.advancementRecommendation,
            isHtml: true,
          },
        ],
      ];
    },
    gridLoaded() {},
    handlerSelectTab({ selectedTab }) {
      if (this.modelTab.systemName != selectedTab.systemName) {
        if (selectedTab.systemName !== "tasks") {
          this.isCompetenceTaskSelected = false;
        }
        this.setAllAccess();
      }
    },
    async getData() {
      if (this.isCopy) {
        const source = await this.competenceService[this.getMethod](this.copySourceId);
        const copyData = Object.fromEntries(
          Object.entries(source.data).filter(([key]) =>
            this.copyingProperties.includes(key)
          )
        );

        this.model = {
          status: "none",
          newStatus: null,
          createdBy: this.userinfo.code,
          developmentPercentage: null,
          ...copyData,
        };

        this.parentTasksExist = source.data.taskTotalCount > 0;

        return;
      }
      if (this.masterId === undefined) {
        this.model = {
          status: "none",
          newStatus: null,
          createdBy: this.userinfo.code,
          developmentPercentage: null,
        };
        return;
      }
      const result = await this.competenceService[this.getMethod](this.masterId);
      this.model = result.data;
      if (this.model) {
        this.model.needFilter = false;
        try {
          let filter = JSON.parse(this.model.filter);
          this.nodeFilter = filter.nodeFilter;
          this.gridFilter = filter.gridFilter;
        } catch {}
        try {
          this.selectedTreeNodes = JSON.parse(this.model.nodeSelection);
        } catch {}

        this.model.comments = this.model.comments.map((value) => {
          return {
            comment: value.comment,
            confirmDate: value.createdAt,
            securityUserFirstName: value.securityUserFullName,
            securityUserType: this.$t(value.securityUserType),
          };
        });
        this.oldStatus = this.model.status;
        this.model.newStatus = this.model.status;
        this.initModel = _.cloneDeep(this.model);
      }
    },
    saveDraft() {
      this.setModelAndSave("Draft");
    },
    publish() {
      this.setModelAndSave("New");
    },
    setModelAndSave(statusCode) {
      this.model.newStatus = statusCode;
      this.save();
    },
    save(dontShowCopyModal = false) {
      if (
        this.parentTasksExist &&
        !dontShowCopyModal &&
        !this.masterId
        // &&
        // this.copySourceDistributorId &&
        // this.copySourceDistributorId === this.model.distributorId
      ) {
        this.showCopyCompetenceTaskMessage = true;
        return;
      }

      this.loading = true;
      const isCreate = !this.masterId;
      let saveMethod = isCreate ? "create" : "update";

      this.model.status = this.model.newStatus;

      const copyTaskCompetenceId =
        this.copyCompetenceRadioButtonModel === "true" && !this.masterId
          ? // &&
            // this.copySourceDistributorId === this.model.distributorId
            this.copySourceId
          : null;

      if (copyTaskCompetenceId && !this.masterId)
        saveMethod = "createcompetencewithtaskcopies";

      this.startDateUpdate();
      this.endDateUpdate();

      this.competenceService[saveMethod](this.model, copyTaskCompetenceId)
        .then(async (result) => {
          if (
            copyTaskCompetenceId &&
            !this.masterId &&
            result.data.isTasksDatesNotEqualToOriginal
          ) {
            this.showCopiedTaskDatesChanged = true;
          }
          this.afterSave(
            result,
            isCreate,
            copyTaskCompetenceId && !this.masterId ? true : false
          );
        })
        .catch(() => {
          this.loading = false;
        });
    },
    afterSave(result, isCreate, isCopied) {
      if (isCreate) {
        this.masterId = !isCopied ? result.data[0].id : result.data.competences[0].id;
      }
      this.getData().then(() => {
        this.setAllAccess(true);
      });

      if (this.modelTab.systemName === "tasks") this.competenceTaskGrid.getRecords(true);
      this.loading = false;

      if (this.model.status != "New") {
        this.$refs["status-ProSpaceDropdown"].localOptions = this.$refs[
          "status-ProSpaceDropdown"
        ].localOptions.filter((object) => {
          return object.code !== "New";
        });
      }
    },
    submitFilter(nameRef = "grid") {
      if (!this.$refs[nameRef]) return;
      this.$refs[nameRef].getRecords(true);
    },
    backHandler() {
      this.$router.go(-1);
    },
    showReasonModal(callback, title) {
      this.modalCallback = async () => {
        await callback();
        this.modalCallback = null;
      };
      this.modalTitle = title;
      this.modalShow = true;
    },
    async addComment() {
      await this.competenceCommentService.create(this.commentItem);
      this.modalModel = this.emptyComment();
      this.getData();
      this.mountAccess();
    },
    saveComment() {
      this.modalCallback();
    },
    cancelComment() {
      this.modalModel = this.emptyComment();
    },
    getStatus(status) {
      if (!status) return;
      let type = "default";
      switch (status.toLowerCase()) {
        case "draft":
          type = "default";
          break;
        case "new":
          type = "light-blue";
          break;
        case "inprogress":
          type = "warning";
          break;
        case "completed":
          type = "success";
          break;
        case "canceled":
          type = "default";
          break;
        default:
          type = "default";
      }
      return {
        text: this.$t(("competenceStatus" + status).toLowerCase()),
        type,
      };
    },
    competenceTaskSelectedHandler(val) {
      this.selectionChanged(val, true);
    },
    selectionChanged(val, isTaskSelected) {
      if (!val.hasSelect) {
        this.selectedMultipleGridHandler({});
        this.isCompetenceTaskSelected = false;
      } else {
        this.selectedMultipleGridHandler(val);
        this.isCompetenceTaskSelected = isTaskSelected;
      }
    },
    handleCompetenceTaskDots(action, item) {
      var option = this.competenceTaskOptions.find((o) => o.name === action);
      option.method(item);
    },
    showCreateTaskModal() {
      this.taskModalId = null;
      this.taskModalCompetence = {
        Id: this.model.id,
        CompetenceDirectoryName: this.model.competenceDirectoryName,
        Status: this.model.status,
      };
      this.taskModalCompetenceStartAt = new Date(this.model.startAt);
      this.taskModalCompetenceEndAt = new Date(this.model.endAt);
      this.showTaskModal = true;
    },
    showEditTaskModal(competenceTask) {
      this.taskModalId = competenceTask.id;
      this.taskModalCompetence = null;
      this.taskModalCompetenceStartAt = new Date(this.model.startAt);
      this.taskModalCompetenceEndAt = new Date(this.model.endAt);
      this.showTaskModal = true;
    },
    showCompetenceTaskHistory(record) {
      this.$refs.competenceTaskHistory.tabs[0].masterId = record.id;
      this.$refs.competenceTaskHistory.masterName = record.name;
      this.$nextTick(() => {
        this.showCompetenceTaskHistoryModal = true;
      });
    },
    closeHistory() {
      this.showCompetenceTaskHistoryModal = false;
    },
    deleteCompetenceTask(model) {
      if (!model) return;
      this.taskDeletingModel = model;
      this.showTaskDeleteModal = true;
    },
    applyTaskDelete() {
      this.competenceTaskService.delete(this.taskDeletingModel).then(() => {
        this.taskDeletingModel = null;
        this.getData();
        this.mountAccess();
      });
    },
    localWrapperCheckRoles(dotsOptions, data) {
      return this.wrapperStatusCheckRoles(
        this.wrapperCheckRoles(dotsOptions, data),
        data
      );
    },
    handleCompetenceTaskModalFormSavedData() {
      this.getData().then(() => {
        this.competenceTaskGrid.getRecords(true);
        if (this.$refs["right-panel"]) this.$refs["right-panel"].update();
      });
    },
    formatMomentDate(dateString) {
      return moment(dateString).format(`${this.userinfo.dateFormat}`);
    },
    startDateUpdate() {
      if (this.model.startAt !== null) {
        let momentDate = moment(this.model.startAt);
        if (
          momentDate.hours() == 0 &&
          momentDate.minutes() == 0 &&
          momentDate.seconds() == 0
        ) {
          this.model.startAt = momentDate.format("YYYY-MM-DDTHH:mm:ss");
          return;
        }

        let startMomentDate = momentDate.startOf("day");
        this.model.startAt = startMomentDate.format("YYYY-MM-DDTHH:mm:ss");
      }
    },
    endDateUpdate() {
      if (this.model.endAt !== null) {
        let momentDate = moment(this.model.endAt);
        if (
          momentDate.hours() == 23 &&
          momentDate.minutes() == 59 &&
          momentDate.seconds() == 59
        ) {
          this.model.endAt = momentDate.format("YYYY-MM-DDTHH:mm:ss");
          return;
        }

        let endMomentDate = momentDate.endOf("day");
        this.model.endAt = endMomentDate.format("YYYY-MM-DDTHH:mm:ss");
      }
    },
  },
  computed: {
    optionsPanel() {
      return {
        fields: {
          Subtasks: {
            type: "modal",
            modalType: "checkbox",
            value: (value) => (value ? this.$t("openList") : ""),
          },
          Attachments: {
            type: "tab-actual",
            value: this.$t("openList"),
            modelName: "CompetenceTaskAttachmentApiModel",
            filterField: "CompetenceTaskId",
            filterValueField: "Id",
          },
          FileLength: {
            value: formatBytes,
          },
          FileName: {
            type: "action",
            fnAction: (value) => {
              const file = {
                name: value.FileName,
                gfid: value.GFID,
              };
              downloadFile(file);
            },
          },
          StartAt: {
            type: "date",
          },
          EndAt: {
            type: "date",
          },
          CompetenceTaskAttachmentApiModel: {
            type: "tab",
            value: this.$t("openList"),
          },
        },
      };
    },
    copyTaskFlashMessageRadioValue() {
      return [
        {
          value: true,
          label: this.$t("createTaskCopies"),
        },
        {
          value: false,
          label: this.$t("doNotCreateTaskCopies"),
        },
      ];
    },
    headerBlockCompetenceDirectories() {
      return {
        title: this.$t("commonInformation"),
        isExpand: false,
      };
    },
    ...mapGetters({
      userinfo: "userinfoStore/getUserinfo",
      getFormatDate: "userinfoStore/getFormatDate",
      access: "securityRoleAccess/access",
      getFormatDateTime: "userinfoStore/getFormatDateTime",
    }),
    refLoading() {
      return this.mixinLoadingAccess || this.statusMixinLoadingAccess;
    },
    refsForCheckInMixin() {
      let refs = [];

      if (this.modelTab.systemName === "parameters") {
        if (!(this.isCreation || this.isDraft || this.isComplete || this.isCanceled))
          refs.push("status-ProSpaceDropdown");

        refs.push(
          "competenceDirectories-ProSpaceSearchfield",
          "levelDevelopment-ProSpaceDropdown",
          "competenceDirectoryBlock-ProSpaceInputText",
          "competenceDirectoryLevel-ProSpaceInputText",
          "competenceDirectoryType-ProSpaceInputText",
          "competenceDirectoryDescription-ProSpaceExtendedTextArea",
          "competenceDirectoryAdvancementRecommendation-ProSpaceExtendedTextArea",
          "startAt-ProSpaceInputCalendar",
          "endAt-ProSpaceInputCalendar",
          "developmentPercentage-ProSpaceInputNumber",
          "businessGoal-ProSpaceExtendedTextArea",
          "expectedResult-ProSpaceExtendedTextArea",
          "metrics-ProSpaceExtendedTextArea",
          "hsrId-ProSpaceSearchfield",
          "areaId-ProSpaceSearchfield"
        );
      }
      if (this.modelTab.systemName === "tasks" && !(this.isCreation || this.isDraft)) {
        refs.push("showCreateTaskModal-ProSpaceButton");
      }
      return refs;
    },
    layoutName() {
      return this.masterId
        ? this.model.competenceDirectoryName
        : this.$t("competenceNew");
    },
    overviewTabs() {
      return [
        {
          name: this.$t("parameters"),
          systemName: "parameters",
          isActive: this.modelTab.systemName === "parameters",
        },
        {
          name: this.$t("tasks"),
          systemName: "tasks",
          isDisabled: this.isCreation || this.isDraft || this.isCopy,
          isActive: this.modelTab.systemName === "tasks",
        },
      ];
    },
    panelBlockHeader() {
      return {
        title: this.model.competenceDirectoryName,
        status: this.getStatus(this.model.status),
      };
    },
    competenceDirectoryFilterService() {
      const filters = [
        {
          type: "chips",
          model: "description",
          label: this.$t("competenceDirectoryDescription"),
          selected: {},
        },
        {
          type: "chips",
          model: "advancementRecommendation",
          label: this.$t("competenceDirectoryAdvancementRecommendation"),
          selected: {},
        },
      ];
      filters.push(
        {
          type: "chips",
          model: "createdBy",
          label: this.$t("createdByTxt"),
          selected: {},
        },
        {
          type: "chips",
          model: "updatedBy",
          label: this.$t("updatedByTxt"),
          selected: {},
        }
      );

      filters.push(
        {
          type: "dates-range-time",
          model: "createdAt",
          label: this.$t("createDate"),
          optionValue: "date",
          selected: {},
          dateFormat: this.userinfo.dateFormat,
        },
        {
          type: "dates-range-time",
          model: "lastUpdated",
          label: this.$t("lastUpdatedTxt"),
          optionValue: "date",
          selected: {},
          dateFormat: this.userinfo.dateFormat,
        }
      );
      return filters;
    },
    isCreation() {
      return !(this.model && this.model.id);
    },
    isCopy() {
      return this.copySourceId && !this.masterId;
    },
    isDraft() {
      return this.model && this.model.id && this.model.status === "Draft";
    },
    isComplete() {
      return this.model && this.model.id && this.model.status === "Completed";
    },
    isCanceled() {
      return this.model && this.model.id && this.model.status === "Canceled";
    },
    disabledDraftSave() {
      return (
        this.v$.model.agencyId.$invalid ||
        this.v$.model.competenceDirectoryId.$invalid ||
        this.v$.model.developmentPercentage.$invalid ||
        this.v$.model.startAt.$invalid ||
        this.v$.model.levelDevelopment.$invalid ||
        this.v$.model.endAt.$invalid
      );
    },
    disabledPublish() {
      return this.v$.model.$invalid;
    },
    disabledSave() {
      return this.v$.model.$invalid || _.isEqual(this.model, this.initModel);
    },
    statusDropdownArgMethod() {
      const userTypeFilter =
        this.model.status == "New"
          ? "code ne 'Draft'"
          : "code ne 'Draft' and code ne 'New'";
      return `$filter=systemDirectoryCode eq 'CompetenceStatus' and ${userTypeFilter} and disabled eq false`;
    },
    commentItem() {
      return {
        comment: this.modalModel.comment || "",
        competenceId: this.model.id,
        createdAt: new Date(),
      };
    },
    mapExpandStatuses() {
      return new Map([
        ["New", { type: "blue", text: this.$t("competencetaskstatusnew") }],
        ["Approving", { type: "teal", text: this.$t("competencetaskstatusapproving") }],
        [
          "RejectedByDistributor",
          {
            type: "error",
            text: this.$t("competencetaskstatusrejectedbydistributor"),
          },
        ],
        ["Planning", { type: "purple", text: this.$t("competencetaskstatusplanning") }],
        [
          "InProgress",
          { type: "warning", text: this.$t("competencetaskstatusinprogress") },
        ],
        [
          "CompleteApproving",
          {
            type: "teal",
            text: this.$t("competencetaskstatuscompleteapproving"),
          },
        ],
        [
          "RejectedByMars",
          {
            type: "error",
            text: this.$t("competencetaskstatusrejectedbymars"),
          },
        ],
        [
          "Completed",
          { type: "success", text: this.$t("competencetaskstatuscompleted") },
        ],
        ["Canceled", { type: "draft", text: this.$t("competencetaskstatuscanceled") }],
      ]);
    },
    competenceTaskOptions() {
      return [
        {
          name: "edit",
          text: this.$t("editItemTxt"),
          icon: "edit",
          method: this.showEditTaskModal,
          liteRef: "editTask-option",
        },
        {
          name: "showHistory",
          text: this.$t("history"),
          icon: "history",
          method: this.showCompetenceTaskHistory,
        },
        {
          name: "delete",
          text: this.$t("delete"),
          icon: "delete",
          method: this.deleteCompetenceTask,
          liteRef: "deletetask-option",
        },
      ];
    },
    copyingProperties() {
      return [
        "competenceDirectoryId",
        "competenceDirectoryName",
        "competenceDirectoryBlock",
        "competenceDirectoryBlockName",
        "competenceDirectoryLevel",
        "competenceDirectoryLevelName",
        "competenceDirectoryType",
        "competenceDirectoryTypeName",
        "competenceDirectoryDescription",
        "competenceDirectoryAdvancementRecommendation",
        "businessGoal",
        "expectedResult",
        "metrics",
        "levelName",
        "blockName",
        "levelDevelopment",
        "developmentPercentage",
      ];
    },
    searchFieldGridStyles() {
      return {
        height: "50vh",
        width: "30vw",
      };
    },
  },
};
</script>
<style lang="scss">
.prospace-competence-input-layout {
  .prospace-input-layout__label {
    font-weight: 400;
  }
}
</style>
